import router from './router'
import useBranchStore from './store'
import BranchMessages from './localization'

export default {
  router,
  useBranchStore,
  localization: BranchMessages,
}
